import { ClbIcon } from '@celebration/react/ClbIcon/ClbIcon';
import i18n from '../../../../../lib/i18n';
import Countdown from '../../../../../common/components/countdown/countdown';
import { useOffersRound } from '../../../../../app/contexts/offers-round/offers-round.context';
import './round-info.scss';

export default function RoundInfo() {
    const { roundState, availableCount, effectedCount, dispatch } =
        useOffersRound();

    return (
        <div className="round-info" data-testid="round-info">
            {roundState.currentPhase !== null && (
                <>
                    <div
                        className="round-info-phase"
                        data-testid="round-info-phase"
                    >
                        <span>
                            {i18n.t('SmartCargas.Rounds.CurrentRound')}:
                        </span>
                        <h3>
                            {i18n.t(
                                `SmartCargas.Rounds.${roundState.currentPhase}`,
                            )}
                        </h3>
                    </div>

                    <div
                        className="round-info-timer"
                        data-testid="round-info-timer"
                    >
                        <div>
                            <ClbIcon icon="time" size="lg" />
                            <h3>
                                <Countdown
                                    targetDateTime={roundState.endingTime}
                                    countdownEndCallback={() =>
                                        dispatch({ type: 'ROUND_ENDING' })
                                    }
                                />
                            </h3>
                        </div>
                        <span>
                            {i18n.t('SmartCargas.Rounds.TotalRoundTime')}
                        </span>
                    </div>

                    <div
                        className="round-info-available"
                        data-testid="round-info-available"
                    >
                        <h3>{availableCount.current}</h3>
                        <span>
                            {i18n.t('SmartCargas.Rounds.AvailablePlural')}
                        </span>
                    </div>

                    <div
                        className="round-info-effected"
                        data-testid="round-info-effected"
                    >
                        <h3>{effectedCount.current}</h3>
                        <span>
                            {roundState.currentPhase === 'Acceptance'
                                ? i18n.t('SmartCargas.Rounds.AcceptedPlural')
                                : i18n.t('SmartCargas.Rounds.ConfirmedPlural')}
                        </span>
                    </div>
                </>
            )}
        </div>
    );
}
